import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class CommonResponse extends GlobalResponseObject{
    [x: string]: any;
    data?: any;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: any) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 